import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CheckboxField = ({
  id,
  label,
  value,
  input = {},
  className,
  inputClassName,
  attributes = {},
  errorMessage = '',
  meta = {},
  showErrorOnChange = false,
  option
}) => {
  const { error, submitFailed, touched } = meta;
  const checkboxFieldClassNames = classNames('CheckboxField custom-control custom-checkbox', className);
  const checkboxId = id ? (id).replace(/\s/g, '-') : null;
  const showError = !!((error && submitFailed) || (error && showErrorOnChange && touched));

  return (
    <div className={checkboxFieldClassNames}>
      <input
        {...input}
        type="checkbox"
        id={checkboxId}
        className={classNames('custom-control-input', inputClassName)}
        {...(value && { value })}
        {...attributes}
        {...(input.value && { defaultChecked: input.value === option })}
      />
      <label
        className="custom-control-label flex"
        htmlFor={checkboxId}
      >
        <span className="checkbox-ui" />
        <div>{label}</div>
      </label>
      {
        showError && (
          <div style={{ marginLeft: '40px' }} className="error text-danger text-small margin-md-top">
            {errorMessage || error}
          </div>
        )
      }
    </div>
  );
};

CheckboxField.propTypes = {
  errorMessage: PropTypes.string,
  meta: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  value: PropTypes.string,
  input: PropTypes.object,
  attributes: PropTypes.object,
  showErrorOnChange: PropTypes.bool,
  option: PropTypes.string
};

export default CheckboxField;
